const AVATAR_COLORS = [
  '#0d5c63', '#7c3aed', '#0369a1', '#b45309',
  '#be185d', '#166534', '#9333ea', '#0f766e',
];

/** Deterministic avatar background color for a user, keyed by a stable id. */
export function colorForUser(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

/** Two-letter avatar initials from a display name, falling back to a user id/email. */
export function initialsForUser(displayName: string | null | undefined, fallbackId: string): string {
  const source = (displayName && displayName.trim()) || fallbackId;
  const parts = source.trim().split(/[\s@._-]+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
